import * as yup from 'yup';

// Custom regex for email validation (requires domain with dot)
// This regex provides stricter rules compared to RFC 5322:
// - Requires dot in domain part (e.g.: @domain.com)
// - Rejects addresses like first_name_2@test
export const emailRegExp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

/**
 * Validates email address using custom regex
 * @param email - email address to validate
 * @returns true if email is valid, false otherwise
 */
export const validateEmail = (email: string): boolean =>
  emailRegExp.test(email);

/**
 * Yup schema for email validation with custom regex
 * Use this schema instead of yup.string().email()
 */
export const emailValidationSchema = yup
  .string()
  .matches(emailRegExp, 'Email is not valid');

/**
 * Yup schema for required email field
 */
export const requiredEmailValidationSchema =
  emailValidationSchema.required('Email is required');
